<div class="dialog-container text-center">
  <h2 matDialogTitle class="visually-hidden">
    {{ (title || message) | translate }}
  </h2>
  <div class="header-wrapper">
    @if (title) {
    <div
      class="dark font-bold font-20 w-100"
      [ngClass]="currentLanguage === 'en' ? 'ml-5' :'mr-5'">
      {{title | translate}}
    </div>
    }
    <div
      class="icon-wrapper"
      matDialogClose
      role="button"
      tabindex="0"
      [attr.aria-label]="'Aria.Close' | translate">
      <i class="bi bi-x-lg"></i>
    </div>
  </div>
  <!-- Main Content of Dialog -->
  <div class="content-wrapper">
    @if (image) {
    <div class="mb-3">
      <img
        [src]="'../../../../assets/images/' + image"
        alt="{{ 'image' | translate }}" />
    </div>
    }
    <div class="row">
      <div class="col-md-12 mb-3 mx-auto">
        @if (message) {
        <p class="font-light-bold dark font-20">{{message | translate}}</p>
        } @if (subMessage) {
        <p class="mt-2 light font-light font-16">
          {{ subMessage | translate }}
        </p>
        }
      </div>
    </div>
  </div>

  <!-- Footer section with the action buttons -->
  <div class="footer-wrapper">
    @if(secondaryTitle){
    <button class="default bg-white" matDialogClose>
      <span> {{ secondaryTitle| translate }}</span>
    </button>
    } @if(primaryBtnTitle){
    <button
      [ngClass]="isDelete ? 'danger' : 'primary'"
      matDialogClose
      (click)="confirm()">
      <span> {{ primaryBtnTitle | translate }} </span>
    </button>
    }
  </div>
</div>
